import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/bg-frames/media.module.scss';

const propTypes = {
    animate: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    animate: false,
    color: '#FF6633',
    className: null,
};

const Media = ({ color, animate, className }) => (
    <svg
        width="1862"
        height="887"
        viewBox="0 0 1862 887"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames([
            styles.container,
            { [className]: className !== null, [styles.animate]: animate },
        ])}
    >
        <g className={styles.boxLeft}>
            <path
                d="M0 102h536v365H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13 102.13h535.75v364.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxLeft}>
            <path
                d="M614 141h172v215H614z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M614.13 141.13h171.75v214.75H614.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxLeft}>
            <path
                d="M817 141h176v215H817z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M817.13 141.13h175.75v214.75H817.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxLeft}>
            <path
                d="M1022 141h176v215h-176z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M1022.13 141.13h175.75v214.75h-175.75z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxLeft}>
            <path
                d="M30 362h204v18H30z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M30.13 362.13h203.75v17.75H30.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxLeft}>
            <path
                d="M30 390h163v18H30z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M30.13 390.13h162.75v17.75H30.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxLeft}>
            <path
                d="M30 418h201v19H30z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M30.13 418.13h200.75v18.75H30.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxRight}>
            <path
                d="M0 499h536v28H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13 499.12h535.75v27.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxRight}>
            <path
                d="M0 544h468v27H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13 544.12h467.75v26.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxRight}>
            <path
                d="M0 588h502v27H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13 588.12h501.75v26.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxRight}>
            <path
                d="M0 634h519v27H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13 634.12h518.75v26.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxRight}>
            <path
                d="M0 680h458v27H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13 680.12h457.75v26.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxRight}>
            <path
                d="M0 718h515v27H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13 718.12h514.75v26.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.targetLeft}>
            <path
                d="M614 380h614v28H614z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M614.13 380.13h613.75v27.75H614.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M614 425h546v27H614z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M614.13 425.13h545.75v26.75H614.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.targetRight}>
            <path
                d="M624 641h614v28H624z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624.13 641.12h613.75v27.75H624.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624 686h614v27H624z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624.13 686.12h613.75v26.75H624.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxRightBottom}>
            <path
                d="M1408 65h454v780h-454z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M1408.13 65.13h453.75v779.75h-453.75z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.boxRightBottomX}>
            <path
                d="M1316 2h454v780h-454z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M1316.13 2.13h453.75v779.75h-453.75z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.barLeftHorizontal1}>
            <path
                d="M0 0h1228v28H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13.13h1227.75v27.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.barLeftHorizontal2}>
            <path
                d="M0 45h1160v27H0z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M.13 45.13h1159.75v26.75H.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.barLeftHorizontal3}>
            <path
                d="M614 469h580v27H614z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M614.13 469.12h579.75v26.75H614.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.barLeftHorizontal3}>
            <path
                d="M614 515h597v27H614z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M614.13 515.12h596.75v26.75H614.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.barLeftHorizontal3}>
            <path
                d="M614 561h536v27H614z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M614.13 561.12h535.75v26.75H614.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.barLeftHorizontal3}>
            <path
                d="M614 599h593v27H614z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M614.13 599.12h592.75v26.75H614.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.barLeftVertical1}>
            <path
                d="M624 730h580v27H624z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624.13 730.12h579.75v26.75H624.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624 776h597v27H624z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624.13 776.12h596.75v26.75H624.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.barLeftVertical1}>
            <path
                d="M624 822h536v27H624z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624.13 822.12h535.75v26.75H624.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624 860h593v27H624z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M624.13 860.12h592.75v26.75H624.13z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
    </svg>
);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;

export default Media;
